<template>
    <div class="lbody">
        <img src="../assets/logo.png" width="360" height="120"  alt="Bluedio">
        <div class="mm">
           <b-form>

                <br>
                <label class="sr-only" for="inline-form-input-username">Username</label>
                <b-input-group prepend="@" class="mb-2 mr-sm-2 mb-sm-0">
                <b-input id="inline-form-input-username" placeholder="Username" v-model="username"></b-input>
                </b-input-group>
                <br>
                <label class="sr-only" for="inline-form-input-username">Password</label>
                <b-input-group prepend="P" class="mb-2 mr-sm-2 mb-sm-0">
                <b-input id="inline-form-input-username" type="password" placeholder="Password"  v-model="password"></b-input>
                </b-input-group>
                <br>
                <b-button size="lg" variant="primary" @click="trackLogin()">Login</b-button>
            </b-form>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import axios from "axios";
export default {
    name: "TrackLogin",
     data() {
        return {
        username: "",
        password: ""
        }
     },
    methods: {
        ...mapActions({
        trackLogin(dispatch) {
        let username = this.username;
        let password = this.password;
        if (username == "" || password == "") {
          this.showToast(this.$t("message.You_need_fill_all_input"));
          return;
        }

        dispatch("trackLogin", { username, password }).then(data => {
          if (data.result) {
            let token = data.token;
            let site_track_location = data.location;
            localStorage.setItem("site_track_token", token);
            localStorage.setItem("site_track_location", site_track_location);
            this.toTrackList();
          } else {
            localStorage.removeItem("site_track_token");
            localStorage.removeItem("site_track_location");
            this.showToast(data.message);
          }
        });
        },
        }),
         toTrackList() {
            this.$router.push({
                name: "TrackList",
            });
        },

      showToast(msg) {
      this.$bvToast.toast(msg, {
        title: ``,
        toaster: "b-toaster-bottom-center",
        solid: true,
        variant: "danger",
        appendToast: false
      });
    },
    }
    

};
</script>

<style scoped>
.lbody {
    margin: 0 auto;
    position: absolute;
    left: 50%;
    top: 25%;
    transform: translate(-50%, -55%);
    text-align: center;
}

.lbody .wd {
    height: 40px;
    line-height: 40px;
    text-align: center;
    background-color: #fff;
    width: 100%;
    cursor: pointer;
    font-size: 1rem;
    margin-left: 0.5em;
    border: 1px solid #454545;
}

.lbody .mm .wd {
    display: inline-block;
    width: 45%;
}

.lbody h2 {
    font-size: 30px;
    font-weight: normal;
    margin-bottom: 1em;
    margin-top: 0.5em;
}
</style>

